// Content Security Policy — dedicated Policy Configuration page.
// See Config.js — this is a thin wrapper that gates the shared
// CspConfig implementation to the "policy" section only.

import React from "react";
import CspConfig from "./Config";

export default function CspPolicy() {
  return <CspConfig section="policy" />;
}
